import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddIcon from "@mui/icons-material/Add";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function CreateMatters() {
  const options = [
    { path: "/case/createMatter", name: "Create Matter" },
    { path: "/case/createTask", name: "Add Task" },
    { path: "/case/addDocument", name: "Add Document" },
  ];

  const userRoleRouters = useSelector((state) => state.userRoleRouters?.route);

  const filteredOptions = React.useMemo(() => {
    if (!userRoleRouters || !Array.isArray(userRoleRouters)) return [];

    const normalize = (path) => (path || "").toLowerCase().trim().replace(/\/+$/, "");

    return options.filter((option) => {
      const targetPath = normalize(option.path);
      for (const group of userRoleRouters) {
        if (group?.url && Array.isArray(group.url)) {
          const matched = group.url.find(
            (u) => normalize(u?.url) === targetPath
          );
          if (matched) {
            return Boolean(matched.edit);
          }
        }
      }
      return false;
    });
  }, [userRoleRouters]);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState("");

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  if (filteredOptions.length === 0) {
    return null;
  }

  return (
    <>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        // sx={options[selectedIndex] && { width: "30%" }}
        aria-label="Button group with a nested menu"
      >
        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <AddIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {filteredOptions.map((option, index) => (
                    <MenuItem
                      key={option.path}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      <Link
                        style={{
                          textDecoration: "none",
                          color:
                            window.location.pathname === option.path
                              ? "primary"
                              : "black",
                        }}
                        to={option.path}
                      >
                        {" "}
                        {option.name}
                      </Link>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
